import { Container } from '@mui/material';
import BasePage from '../BasePage';
import AdminLayout from '../../components/AdminLayout';
import AdminPageHeader from '../../components/admin/shared/AdminPageHeader';
import AdminLoadingState from '../../components/admin/shared/AdminLoadingState';
import ToolsTabs from '../../components/admin/tools/ToolsTabs';
import { useAdminTools } from '../../hooks/admin/useAdminTools';

/**
 * AdminTools - Tools and utilities page
 *
 * Section 8: Tools & Utilities
 * - Audit log viewer with comprehensive activity tracking
 * - Database tools (query interface, schema browser)
 * - Bulk operations for mass data management
 * - System configuration (feature flags, settings, maintenance)
 */
export default function AdminTools() {
  const {
    toolsData,
    isLoading,
    refresh,
    executeQuery,
    toggleFeatureFlag,
    updateSystemSetting,
    runMaintenanceOperation,
  } = useAdminTools();

  if (isLoading && !toolsData) {
    return <AdminLoadingState message="Loading admin tools..." />;
  }

  return (
    <BasePage title="Admin Tools | CribCritic Admin" description="Admin tools">
      <AdminLayout>
        <Container maxWidth="xl">
          <AdminPageHeader
            title="Tools & Utilities"
            subtitle="Advanced admin tools for database management, audit logging, and system configuration"
          />

          <ToolsTabs
            data={toolsData}
            loading={isLoading}
            onRefresh={refresh}
            onExecuteQuery={executeQuery}
            onToggleFeatureFlag={toggleFeatureFlag}
            onUpdateSystemSetting={updateSystemSetting}
            onRunMaintenanceOperation={runMaintenanceOperation}
          />
        </Container>
      </AdminLayout>
    </BasePage>
  );
}
